import React from "react";
import { classNames } from "../../helper/classNames";

const IdenticalCheckbox = ({
  checkboxName,
  checkboxInputClass,
  isChecked,
  checkboxClass,
  checkboxLabel,
  checkboxLableClass,
  strike = false,
  checked,
  divClass,
  value,
  loading = false,
  disabled = false,
  onChange = () => {},
  ...props
}) => {
  return (
    <>
      <div
        className={classNames(
          "relative overflow-hidden flex flex-shrink-0",
          divClass
        )}
      >
        <input
          type="checkbox"
          name={checkboxName}
          className={classNames(
            "peer absolute top-0 left-0 w-5 h-5 opacity-0 z-10 cursor-pointer",
            checkboxInputClass
          )}
          checked={checked}
          // defaultChecked={isChecked}
          value={value}
          onChange={onChange}
          disabled={disabled}
        />
        <div
          className={classNames(
            "relative overflow-hidden w-5 h-5 flex-shrink-0 border border-slate-300 rounded flex items-center justify-center text-sm bg-white text-black/0 peer-checked:bg-teal-500 peer-checked:border-teal-500 peer-checked:text-white",
            checkboxClass
          )}
        >
          <i className="fa-light fa-check"></i>
        </div>
        {checkboxLabel && (
          <div
            className={classNames(
              "text-sm text-opplio-gray w-full ml-3 transition-all duration-200",
              strike ? "peer-checked:line-through" : "",
              checkboxLableClass
            )}
          >
            {checkboxLabel}
          </div>
        )}
      </div>
    </>
  );
};

export default IdenticalCheckbox;
